/* eslint-disable array-bracket-newline */
import { Network } from '@kattana-io/common';
import { useState } from 'react';
import Text from '../../../atoms/Text';
import { formatAddress } from '../../../helpers/formatters';
import BalanceMenu from '../balanceMenu';
import useWalletSelect, { wallet } from './useWalletSelect';

import './styles.scss';

interface IWalletSelectProps {
  error: boolean;
  balances: any;
  mapping: any;
  network: Network;
  rates: any;
  loading: boolean;
  currentWallet: wallet;
  onConnect(): void;
  onLogout(): void;
  onClose(): void;
}

const splitByChunks = (array: any[], chunk_size: number) =>
  array
    .map((_, i, all) => all.slice(i * chunk_size, (i + 1) * chunk_size))
    .filter((x) => x.length);

const WalletSelect = ({
  currentWallet,
  onConnect,
  error,
  rates,
  balances,
  network,
  mapping,
  loading,
  onLogout,
  onClose,
}: IWalletSelectProps) => {
  const availableWallets = useWalletSelect({ current: currentWallet });
  const [showWallets, setShowWallets] = useState(false);

  const rows = splitByChunks(availableWallets.list, 2);

  const showWalletsStyle = showWallets
    ? 'icon-chevron-down'
    : 'icon-chevron-top';

  return (
    <div className='select_wallet'>
      <div className='select_wallet__body'>
        <div className='select_wallet__body__active'>
          <div className='select_wallet__body__active__title'>
            <Text size={12} className='text--weight-600 text--grey-600'>
              The wallet in default
            </Text>
          </div>
          <div className='select_wallet__body__active__content'>
            <div className='select_wallet__body__active__content__description'>
              <div className='select_wallet__body__active__content__description__wallet'>
                <div className='select_wallet__body__active__content__description__wallet__address'>
                  <div className='select_wallet__body__active__content__description__wallet__address__icon icon-wallet' />
                  <Text size={14} className='text--navy-600'>
                    {formatAddress(availableWallets.active.address)}
                  </Text>
                </div>
                <div className='select_wallet__body__active__content__description__wallet__badge'>
                  <Text size={12} className='text--green-600'>
                    Active
                  </Text>
                </div>
              </div>
              <div className='wallet_amount'>
                <Text size={14} className='text--weight-500 text--grey-200'>
                  {availableWallets.active.amount}
                </Text>
                <Text size={14} className='text--grey-400'>
                  {availableWallets.active.nativeToken}
                </Text>
              </div>
            </div>
            <div
              className='select_wallet__body__active__content__logout'
              onClick={onLogout}
            >
              <div className='select_wallet__body__active__content__logout__icon icon-logout-alt' />
            </div>
          </div>
        </div>

        <div className='select_wallet__body__available'>
          <div
            className='select_wallet__body__available__title'
            onClick={() => setShowWallets(!showWallets)}
          >
            <div
              className={`select_wallet__body__available__title__icon ${showWalletsStyle}`}
            />
            <Text size={12} className='text--weight-600 text--grey-600'>
              Change to another
            </Text>
          </div>
          {showWallets && availableWallets.list.length > 0 && (
            <div className='select_wallet__body__available__wallets_table'>
              {rows.map((row, rowIdx) => (
                <div
                  key={rowIdx}
                  className='select_wallet__body__available__wallets_table__row'
                >
                  {row.map((wallet, index) => (
                    <div
                      key={index}
                      className='select_wallet__body__available__wallets_table__row__item'
                    >
                      <Text size={12} className='text--navy-600'>
                        {formatAddress(wallet.address)}
                      </Text>
                      <div className='wallet_amount'>
                        <Text size={14} className='text--grey-400'>
                          {wallet.amount}
                        </Text>
                        <Text size={14} className='text--grey-400'>
                          {wallet.network}
                        </Text>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className='select_wallet__body__add' onClick={onConnect}>
          <Text size={12} className='text--weight-600 text--white'>
            Add new wallet
          </Text>
        </div>

        <BalanceMenu
          error={error}
          loading={loading}
          mapping={mapping}
          rates={rates}
          balances={balances}
          network={network}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default WalletSelect;
